import { number, object } from 'yup';
import { CycleSettingAction } from '../../enums/action';
import { PercentageTimerActions } from '../../types/cycle-settings-types';
import i18n from '../../infrastructure/i18n';

export const PERCENTAGE_TIMER_SETTINGS_LIMITS = {
  PT: {
    MIN: 0,
    MAX: 100,
  },
};

export const actions: PercentageTimerActions[] = [
  {
    inputType: 'number',
    actionName: CycleSettingAction.SET_PERCENTAGE_TIMER,
    actionField: 'PT',
    labelText: i18n.t('cycle.settings.percentageTimer.PT'),
    editableKey: 'percentage_timer',
    validationSchema: object({
      PT: number()
        .typeError(i18n.t('errors.numberValue.typeError', '', { type: 'number' }))
        .min(
          PERCENTAGE_TIMER_SETTINGS_LIMITS.PT.MIN,
          `${i18n.t('errors.numberValue.min', '', { minNum: PERCENTAGE_TIMER_SETTINGS_LIMITS.PT.MIN })}`,
        )
        .max(
          PERCENTAGE_TIMER_SETTINGS_LIMITS.PT.MAX,
          `${i18n.t('errors.numberValue.max', '', { maxNum: PERCENTAGE_TIMER_SETTINGS_LIMITS.PT.MAX })}`,
        )
        .required(i18n.t('errors.requiredValue')),
    }),
  },
];

export const settingActions = [
  {
    labelText: i18n.t('cycle.settings.postWeld.recipeName'),
    fieldName: 'name',
  },
  {
    labelText: i18n.t('cycle.settings.mode'),
    fieldName: 'mode',
  },
  {
    labelText: 'PT',
    fieldName: 'pt',
  },
]
